import { Card, Empty } from "antd"

export const AppointmentForm = ({ appointment }) => {
  return (
    <Card>
      <Empty description='Tính năng đang phát triển' />
    </Card>
  )
}